module.exports = __webpack_public_path__ + "img/swingVariabilityText6.c953eddc.png";